import modal from "./modal";

const openVideo = (() => {
  const _o = {
    selectors: {
      target: "modal-video",
      title: "[data-video-title]",
      description: "[data-video-description]"
    },
    trigger: document.querySelectorAll( '[data-open-video], [href="#showreel"]' ),
    swiper: document.querySelector(".slider-main"),
    target: {},
  };

  const init = () => {
    getTarget();
    _o.trigger.forEach((el) => initEvents(el));
  };

  const initEvents = (el) => {
    const component = {
      element: el,
      // title: el.querySelector(_o.selectors.title),
      description: el.querySelector(_o.selectors.description)
    };

    el.addEventListener("click", (e) => onClickOpen(e, component) );
  };

  const getTarget = () => {
    const el = document.getElementById( _o.selectors.target );
    _o.target.element = el;
    _o.target.iframe = el.querySelector("iframe");
    // _o.target.title = el.querySelector(_o.selectors.title);
    _o.target.description = el.querySelector(_o.selectors.description);
  };

  const onClickOpen = (e, component) => {
    e.preventDefault();
    let href = component.element.href;
    if(href.includes("#showreel")) {
      href = showreel;

      _o.target.element.classList.add("modal-wide");

      if(_o.swiper)
        _o.swiper.swiper.autoplay.stop();
    } else {
      _o.target.element.classList.contains("modal-wide") && _o.target.element.classList.remove("modal-wide");
    }

    _o.target.iframe.setAttribute("src",  href);
    // _o.target.title.innerHTML = ((component.title)) ? component.title.innerHTML : "Showreel";
    _o.target.description.innerHTML = ((component.description)) ? component.description.innerHTML : "";

    setTimeout(function(){ modal.openModal(_o.selectors.target); }, 100);

  };

  return {
    init: init
  };
})();

export default openVideo;
